import {Pipe, PipeTransform} from '@angular/core';
import {FaqModel} from '../models/faq.model';

@Pipe({name: 'trierParNumeroFaq'})
export class TrierParNumeroFaq implements PipeTransform {
  transform(arr: FaqModel[], args: any): FaqModel[] {
    if (!arr) {
      return;
    }
    return arr.sort((a, b) => {
      if (parseInt(a.numero, 10) > parseInt(b.numero, 10)) {
        return 1;
      }
      if (parseInt(a.numero, 10) < parseInt(b.numero, 10)) {
        return -1;
      }
      return 0;
    });
  }
}
